export default "__VITE_ASSET__B_LCNA6w__"